import { IFooterL10nData, langType, countryType, IFooterConfig, IFooterConfigAllwithDefault, IChangeLanguage } from '../interface/IFooter';
import { footerL10n, footerL10nLang } from './L10n';
export default class DataStore {
    private static _instance: DataStore;

    public lang! : langType;
    public country! : countryType;
    public service! : string;
    public config! : IFooterConfig;
    public l10n! : IFooterL10nData;
    public l10nLang! : IChangeLanguage;
    public countryData! : Array<{country: string, text: string}>
    public geoCountry! : countryType;

    private constructor() {
    }

    public static get instance(){
        return this._instance || (this._instance = new this())
    }

    public init(_config: IFooterConfigAllwithDefault){
        const htmlEl = document.querySelector('html');
        if(htmlEl){
            this.lang = (htmlEl.getAttribute('lang') || 'ko') as langType;
            this.country = (htmlEl.getAttribute('data-country') || 'KR') as countryType;
            this.service = (htmlEl.getAttribute('data-service') || 'plaync');
            this.l10n = footerL10n[this.lang];
            this.l10nLang = footerL10nLang;
            this.config = this.setConfig(_config);
            this.countryData = this.sortCountry(this.config.countryList);
            for(var i in window){
                if(i === '_geolocationCountry'){
                    this.geoCountry = window[i] as unknown as countryType;
                }
            }
        }
    }

    setConfig(_config: IFooterConfigAllwithDefault): IFooterConfig{
        let defaultConfig: IFooterConfig = _config.default;
        let currentConfig: IFooterConfig = _config[this.country];

        if(currentConfig){
            Object.assign(defaultConfig, currentConfig);
        }

        return defaultConfig;
    }

    sortCountry(_countryList: Array<countryType>){
        const countryL10n = _countryList.map(it =>{
            return{
                country: it,
                text: this.l10n.country[it]
            }
        });

        return countryL10n.sort((a,b) => a.text.localeCompare(b.text, this.lang));
    }
}